export default "__VITE_ASSET__Btuicssf__"